import * as React from 'react'
// components
import BaseMultiValueLabel from './Basic'
import SecurityMultiValueLabel from './Security'
// constants
import { Forms } from 'constants/forms'
import { ENTITIES } from 'constants/entities'
// types
import { IField } from 'types/graphql'
import { IOption } from 'components/FormElements/Select'
import { WrappedFieldMetaProps } from 'redux-form/lib/Field'
import { MultiValueGenericProps } from 'react-select'

export type MultiValueLabelProps = MultiValueGenericProps<IOption> & {
  selectProps: SelectProps
}

interface SelectProps {
  meta: WrappedFieldMetaProps
  field: IField
  canSetPermissions: boolean
}

const MultiValueLabel: React.FC<MultiValueLabelProps> = (props) => {
  const {
    data: { entity },
    selectProps: {
      field,
      canSetPermissions,
      meta: { form }
    }
  } = props

  const canSetSecurity =
    canSetPermissions &&
    (field.name === 'membersUserPosition' ||
      (form === Forms.RISK_TEMPLATE_FORM && (!entity || [ENTITIES.USER, ENTITIES.POSITION].includes(entity))))

  return canSetSecurity ? <SecurityMultiValueLabel {...props} /> : <BaseMultiValueLabel {...props} />
}

export default MultiValueLabel
